// extracted by mini-css-extract-plugin
module.exports = {"pageProduct":"product_pageProduct__hNN1t"};